export default __webpack_public_path__ + "static/media/anthem-website-logos_nrdc-e1632433716712.ee97cfc3.webp";